import { h } from 'preact';
const Popup = ({ open, children, className = '', onClose, showCloseBtn = true }) => open
    ? h("div", null,
        h("div", null,
            h("div", { className: "overlay--bg", onclick: onClose }),
            h("div", { className: `overlay ${className}` },
                showCloseBtn ? h("button", { className: "btn--close", onclick: onClose }, "x") : null,
                children)))
    : null;
export default Popup;
